import { render, staticRenderFns } from "./RentACarDescriptions.vue?vue&type=template&id=28fae764&scoped=true"
import script from "./RentACarDescriptions.vue?vue&type=script&lang=js"
export * from "./RentACarDescriptions.vue?vue&type=script&lang=js"
import style0 from "./RentACarDescriptions.vue?vue&type=style&index=0&id=28fae764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fae764",
  null
  
)

export default component.exports